export default "__VITE_ASSET__e484cba0__"